import styled from 'styled-components'
import CatalogContents from './components/CatalogContents'

function PageCatalogPc() {
  return (
    <MainContainer>
      <CatalogContents isMobile={false} />
    </MainContainer>
  )
}

export default PageCatalogPc

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-top: 82px;
  width: 100vw;
  overflow-x: hidden;
  padding-bottom: 102px;
  background: #f7f7f7;
`
